/**
 * @author Jafar Amini in March 2018.
 */
import {Keyword} from './keyword';
export class State {
  keyword: Keyword;
  message: string;
}
